<template>
  <Swiper
    ref="mySwiper"
    :options="swiperConfig"
    :cleanup-styles-on-destroy="false"
  >
    <SwiperSlide v-for="image in images" :key="image._key">
      <Media :image="image" :ratio="false" />
    </SwiperSlide>
    <div v-if="hasMultiple" slot="button-prev" class="swiper-prev">
      <SvgIcon icon="arrow-left" />
    </div>
    <div v-if="hasMultiple" slot="button-next" class="swiper-next">
      <SvgIcon icon="arrow-right" />
    </div>
  </Swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import Media from '@/components/Media'
import SvgIcon from '@/components/SvgIcon'

export default {
  name: 'MediaSlideshow',
  props: {
    images: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  components: { Media, SvgIcon, Swiper, SwiperSlide },
  data() {
    return {
      swiperConfigDefault: {
        autoHeight: false,
        keyboard: true,
        allowTouchMove: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      }
    }
  },
  computed: {
    hasMultiple() {
      return this.images.length > 1
    },
    swiper() {
      return this.$refs.mySwiper.$el.swiper
    },
    swiperConfig() {
      return {
        ...this.swiperConfigDefault,
        allowTouchMove: this.hasMultiple
      }
    }
  },
  mounted() {
    this.swiper.slideTo(this.index, 0, false)
  }
}
</script>

<style scoped>
.swiper-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.swiper-prev,
.swiper-next {
  position: absolute;
  top: 0;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 var(--page-padding);
  transition: 200ms opacity;
  cursor: pointer;
  outline: none;
  z-index: 2;
  &.swiper-button-disabled {
    opacity: 0;
    pointer-events: none;
  }
}
.swiper-prev {
  left: 0;
}
.swiper-next {
  right: 0;
  align-items: flex-end;
}
/deep/ .swiper-slide {
  --aspect-ratio: 1;
  figure {
    --arrow-width: 2.5em;
    --figure-height: calc(100vh - var(--page-padding) * 2 - 1.5em);
    --figure-width: calc(var(--figure-height) * var(--aspect-ratio));
    --figure-width-max: calc(
      100% - var(--page-padding) * 2 - var(--arrow-width) * 2
    );
    position: absolute;
    top: var(--page-padding);
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    width: var(--figure-width);
    max-width: var(--figure-width-max);
    height: var(--figure-height);
    display: flex;
    flex-direction: column;
    @mixin breakpoint-medium {
      --figure-height: calc(100vh - var(--page-padding) * 2 - 0.5em);
    }
  }
  figcaption {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    transform: translateY(100%);
    @mixin truncate-ellipsis;
    padding-top: 0.25em;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
